
import { Component, Vue } from 'vue-property-decorator';

import FormModule from '@/store/modules/form';
import { getStateSelectorItems } from '@/utils/global.util';

@Component({})
export default class ContactUsForm extends Vue {
  contactUsOptionSelectorItems: SelectorItem[];
  contactUsOptionsPolling: any;
  formStores: FormStore[];
  formModel: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    city: string;
    state: string;
    zip: number | null;
    store: string;
    dateOfVisit: Date | null;
    timeOfVisit: string;
    comments: string;
    selectedOption: string;
    contactBy: string;
  };

  data() {
    return {
      contactUsOptionSelectorItems: [],
      contactUsOptionsPolling: null,
      formStores: null,
      formModel: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        city: '',
        state: '',
        zip: null,
        store: '',
        dateOfVisit: null,
        timeOfVisit: '',
        comments: '',
        selectedOption: '',
        contactBy: '',
      }
    }
  }

  async mounted() {
    const stores = await FormModule.getFormStores();
    this.formStores = stores;

    this.contactUsOptionsPolling = setInterval(async () => {
      const contactUsOptions = window?.__INITIAL_STATE__?.contactUsOptions;
      if (contactUsOptions) {
        clearInterval(this.contactUsOptionsPolling);
        const results: SelectorItem[] = [];
        const parsedContactUsOptions = contactUsOptions.split(',');

        results.push({
          value: '',
          id: '',
          label: ''
        });

        parsedContactUsOptions.forEach((option) => {
          const trimmed = option.trim();
          results.push({
            value: trimmed,
            id: trimmed,
            label: trimmed
          });
        });
        this.contactUsOptionSelectorItems = results;
      }
    }, 500);
  }

  beforeDestroy() {
    if (this.contactUsOptionsPolling) {
      clearInterval(this.contactUsOptionsPolling);
    }
  }

  get states() {
    return getStateSelectorItems();
  }

  get timeOfVisitItems() {
    const results: SelectorItem[] = [];

    results.push({
      value: '',
      id: '',
      label: ''
    });

    results.push({
      value: 'Morning (Open - 11a.m.)',
      id: 'Morning (Open - 11a.m.)',
      label: 'Morning (Open - 11a.m.)'
    });

    results.push({
      value: 'Lunch (11a.m. - 1p.m.)',
      id: 'Lunch (11a.m. - 1p.m.)',
      label: 'Lunch (11a.m. - 1p.m.)'
    });

    results.push({
      value: 'Afternoon (1p.m. - 5p.m.)',
      id: 'Afternoon (1p.m. - 5p.m.)',
      label: 'Afternoon (1p.m. - 5p.m.)'
    });

    results.push({
      value: 'Dinner (5p.m. - 7p.m.)',
      id: 'Dinner (5p.m. - 7p.m.)',
      label: 'Dinner (5p.m. - 7p.m.)'
    });

    results.push({
      value: 'Close (7p.m. - Close)',
      id: 'Close (7p.m. - Close)',
      label: 'Close (7p.m. - Close)'
    });

    return results;
  }

  get stores() {
    const stores = this.formStores;
    const results: SelectorItem[] = [];

    if (!stores) {
      return;
    }

    results.push({
      value: '',
      id: '',
      label: ''
    });

    stores.forEach((formStore) => {
      results.push({
        value: formStore.storeNumber,
        id: formStore.storeNumber,
        label: formStore.name
      });
    });

    return results;
  }

  async submitHandler(formModel) {
    const loader = this.$loading.show();
    try {
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('contactus');

      await FormModule.submitContactUs({ ...formModel, recaptchaToken: token } as ContactUsRequest)
      this.$toasted.success('Your message was sent successfully!');
      this.formModel = {
        ...formModel,
        store: '',
        dateOfVisit: null,
        timeOfVisit: '',
        comments: '',
        selectedOption: ''
      };
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      loader.hide();
    }
  }
}
